import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class WfsDirectAjaxService {

    private ajaxUrl = '/wp-admin/admin-ajax.php';
    private action  = 'wfs_direct_ajax';
    private headers: HttpHeaders;

    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders({'Content-Type' : 'application/x-www-form-urlencoded'});
    }

    post(requestData = {}): Observable<any> {
        const params = Object.assign(requestData, {
            action: this.action
        });

        let httpParams = new HttpParams();
        Object.keys(params).forEach(function (key) {
            httpParams = httpParams.append(key, requestData[key]);
        });

        return this.http.post(this.ajaxUrl, httpParams, {
            headers: this.headers
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/wfs-direct-ajax.service.ts